import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'AI-Powered Solution',
        content: 'Revolutionize your business with our custom-built AI solutions designed to drive innovation.',
        paragraphs: [
            'Our AI solutions are tailored to meet the unique needs of your business. From predictive analytics to intelligent automation, we help you harness the power of AI for optimal performance.',
            'With cutting-edge algorithms, real-time data processing, and seamless integration, our solutions empower you to make data-driven decisions and enhance customer experiences.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Custom AI models for specific business needs',
            'Real-time data analysis and insights',
            'Seamless integration with existing systems',
            'Scalable and secure architecture',
            'Continuous performance optimization'
        ],
        process: [
            'Identify business challenges and goals',
            'Develop and train custom AI models',
            'Integrate AI solutions into your workflow',
            'Monitor performance and provide insights',
            'Continuously optimize for better results'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How can AI improve my business operations?',
                content: 'AI can automate repetitive tasks, analyze large datasets for insights, and enhance customer experiences through personalized solutions.'
            },
            {
                id: 2,
                heading: 'Is the AI solution customizable?',
                content: 'Yes, our AI models are fully customizable to meet the unique requirements of your business.'
            },
            {
                id: 3,
                heading: 'What industries can benefit from AI solutions?',
                content: 'Our AI solutions cater to various industries, including healthcare, finance, e-commerce, and manufacturing.'
            },
            {
                id: 4,
                heading: 'How secure is the AI solution?',
                content: 'We prioritize data security and implement robust encryption and compliance standards to protect your data.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'IT Consulting',
        content: 'Get expert advice and strategic direction for your IT infrastructure to enhance efficiency.',
        paragraphs: [
            'Our IT consulting services provide businesses with tailored strategies to optimize their IT infrastructure. From system integration to cybersecurity solutions, we help you achieve operational excellence.',
            'With a team of experienced consultants, we assess your current systems, identify potential risks, and recommend innovative solutions to enhance productivity and security.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Comprehensive IT infrastructure analysis',
            'Customized solutions for business needs',
            'Enhanced cybersecurity measures',
            'Seamless system integration',
            'Continuous support and maintenance'
        ],
        process: [
            'Initial assessment of your IT systems',
            'Identify challenges and opportunities',
            'Develop a customized strategy',
            'Implement solutions and monitor performance',
            'Provide ongoing support and optimization'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What industries do you specialize in?',
                content: 'We cater to a wide range of industries, including finance, healthcare, manufacturing, and more.'
            },
            {
                id: 2,
                heading: 'How do you assess our IT infrastructure?',
                content: 'We conduct a thorough analysis of your current systems, security protocols, and performance metrics to identify areas for improvement.'
            },
            {
                id: 3,
                heading: 'Do you offer ongoing support?',
                content: 'Yes, we provide continuous support and maintenance to ensure your IT systems run smoothly and securely.'
            },
            {
                id: 4,
                heading: 'Can you assist with cloud integration?',
                content: 'Absolutely. We specialize in seamless cloud integration to enhance scalability and efficiency.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Cloud Integration',
        content: 'Streamline your operations with secure and scalable cloud solutions tailored to your needs.',
        paragraphs: [
            'Our cloud integration services enable seamless migration and management of your IT infrastructure. We help businesses leverage cloud technologies to enhance performance and reduce operational costs.',
            'With advanced security protocols and scalable architecture, we ensure a smooth transition to the cloud, allowing you to focus on innovation and growth.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Seamless cloud migration and deployment',
            'Enhanced data security and compliance',
            'Scalable infrastructure to meet business demands',
            '24/7 monitoring and support',
            'Cost-effective and efficient solutions'
        ],
        process: [
            'Assess your current IT infrastructure',
            'Develop a customized cloud strategy',
            'Execute migration with minimal downtime',
            'Implement security and compliance measures',
            'Monitor and optimize performance'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What cloud platforms do you support?',
                content: 'We support major cloud platforms like AWS, Microsoft Azure, and Google Cloud Platform.'
            },
            {
                id: 2,
                heading: 'Is data security ensured during migration?',
                content: 'Yes, we implement robust encryption and compliance measures to protect your data.'
            },
            {
                id: 3,
                heading: 'How long does the integration process take?',
                content: 'The duration depends on the complexity of your infrastructure, but we aim for minimal disruption.'
            },
            {
                id: 4,
                heading: 'Do you offer post-integration support?',
                content: 'Yes, we provide ongoing monitoring and support to optimize your cloud environment.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Code Development',
        content: 'Create bespoke software solutions tailored to your business goals, ensuring agility and growth.',
        paragraphs: [
            'Our code development services focus on building custom software solutions that drive innovation and efficiency. From web applications to enterprise-level platforms, we deliver scalable and high-performance code.',
            'With a team of experienced developers and cutting-edge technologies, we ensure that your software meets business objectives and adapts to future growth.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Custom software solutions for your business needs',
            'Agile development process for flexibility and speed',
            'High-quality, scalable, and secure code',
            'Integration with existing systems',
            'Continuous support and maintenance'
        ],
        process: [
            'Understand business requirements and goals',
            'Design and architect the software solution',
            'Develop and test the code',
            'Deploy and integrate with your systems',
            'Ongoing support and enhancements'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of software solutions do you develop?',
                content: 'We specialize in web applications, mobile apps, enterprise platforms, and custom API development.'
            },
            {
                id: 2,
                heading: 'How do you ensure code quality?',
                content: 'We follow best coding practices, conduct rigorous testing, and implement code reviews to ensure high-quality code.'
            },
            {
                id: 3,
                heading: 'Can you integrate with existing systems?',
                content: 'Yes, our solutions are designed to seamlessly integrate with your current infrastructure and third-party tools.'
            },
            {
                id: 4,
                heading: 'What technologies do you use for development?',
                content: 'We work with a wide range of technologies, including JavaScript, Python, React, Node.js, and more.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Cyber Protection',
        content: 'Protect your digital assets with cutting-edge security measures and proactive management.',
        paragraphs: [
            'Our Cyber Protection solutions are designed to safeguard your critical data and infrastructure from potential threats. With advanced security protocols and real-time monitoring, we ensure your business remains secure and resilient.',
            'From threat detection to incident response, our comprehensive approach helps prevent cyberattacks and minimizes downtime, allowing you to focus on business growth.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            '24/7 threat monitoring and detection',
            'Advanced firewall and encryption measures',
            'Regular security audits and compliance checks',
            'Incident response and recovery solutions',
            'Proactive risk management strategies'
        ],
        process: [
            'Assess your current security posture',
            'Implement robust security measures',
            'Monitor threats in real-time',
            'Respond to incidents swiftly',
            'Continuously optimize for enhanced protection'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of cyber threats do you protect against?',
                content: 'We protect against malware, phishing attacks, ransomware, and other sophisticated cyber threats.'
            },
            {
                id: 2,
                heading: 'Do you offer compliance support?',
                content: 'Yes, we ensure compliance with industry standards like GDPR, HIPAA, and PCI-DSS.'
            },
            {
                id: 3,
                heading: 'How often do you conduct security audits?',
                content: 'We perform regular audits to identify vulnerabilities and ensure optimal security performance.'
            },
            {
                id: 4,
                heading: 'Can you provide incident response support?',
                content: 'Absolutely. Our team is equipped to handle incidents and minimize the impact on your operations.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Big Data Analytics',
        content: 'Unlock the power of your data with our analytics solutions to drive informed growth.',
        paragraphs: [
            'Our Big Data Analytics solutions provide deep insights into your business operations. By leveraging advanced algorithms and machine learning models, we help you make data-driven decisions and identify growth opportunities.',
            'With real-time data processing, visualization tools, and predictive analytics, we enable you to uncover hidden patterns and trends for better business strategies.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Advanced data analysis and visualization',
            'Real-time data processing and reporting',
            'Customizable dashboards and reports',
            'Predictive analytics for future insights',
            'Seamless integration with existing systems'
        ],
        process: [
            'Collect and preprocess data from various sources',
            'Apply advanced algorithms and machine learning models',
            'Generate real-time insights and reports',
            'Visualize data for better decision-making',
            'Continuously optimize analytics for improved outcomes'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How can Big Data Analytics benefit my business?',
                content: 'It helps in identifying trends, improving decision-making, and discovering new revenue opportunities by analyzing large datasets.'
            },
            {
                id: 2,
                heading: 'Is the solution customizable?',
                content: 'Yes, our analytics platform is fully customizable to meet your business needs and objectives.'
            },
            {
                id: 3,
                heading: 'What industries can benefit from Big Data Analytics?',
                content: 'Industries such as healthcare, finance, retail, and manufacturing can greatly benefit from data-driven insights.'
            },
            {
                id: 4,
                heading: 'How secure is my data?',
                content: 'We prioritize data security with encryption and compliance standards to protect your sensitive information.'
            }
        ]
    },
];

export default services;